import React, { useState, useEffect } from "react";
import { Modal } from "../../../../components/others/Modal/index";
import { useForm } from "react-hook-form";
import { Input } from "../../../../components/core/Input";
import { PrimaryButton } from "../../../../components/others/ButtonPrimary";
import { OnSubmitTypes, TProps } from "../onSubmitTypes.types";
import LavorisService from "../../../../services/LavorisService";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/combineReducer";
import { useAlert } from "../../../../hooks/useAlert";
import { getErrorMessage } from "../../../../utils";
import InputRadio from "../../../../components/others/InputRadio/InputRadio";
import { PhoneNumber } from "../../../../components/others/PhoneNumber";

const AddRRHH = ({ show, urlTittle, onClose, modalTittle,tableLoading }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold my-6";
  const {
    register,
    reset,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<OnSubmitTypes>({ mode: "all" });

  const [isLoading, setIsLoading] = useState(false);
  const LavorisInstance = LavorisService.getInstance();
  const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);
  const { showAlert } = useAlert()

  const onSubmit = async (data: OnSubmitTypes) => {
    setIsLoading(true);

    try {

      const dataToSubmit = {
        ...data,
        companyId: currentCompany.id,
        name: `${data.lastName}, ${data.firstName}`,
        roles: ["RRHH"],
        password: new Date(Date.now()).toString(),
        phoneNumber: data.phoneNumber,
        billingEmailEnabled: data.billingEmailEnabled === 'Si' ? true : false,
      };

      const emailToUpdate = {
        email: dataToSubmit.email,
        billingEmailEnabled: dataToSubmit.billingEmailEnabled
      }

      let companyId = currentCompany.id
      
      const user = await LavorisInstance.User.createUsersByRoleAlias(dataToSubmit);
      await LavorisInstance.CompanyServices.updateCompanyEmails(companyId, emailToUpdate)
      if (user.username != data.email) {
        alert(`El usuario de ingreso va a ser ${user.username}`)
      }
      onClose?.();
      tableLoading?.();
    } catch (err) {
      console.log(err);
      showAlert(getErrorMessage({ title: 'Error al crear el rol de RRHH', err }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    reset();
  }, []);

  return (
    <Modal
      show={show}
      urlTittle={urlTittle}
      modalTitle={modalTittle}
      onClose={() => onClose?.()}
      titleStyle={styles}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col justify-between align-middle gap-4"
      >
        <Input
          type="text"
          label="Apellido"
          fieldName="lastName"
          register={register}
          required
          error={errors.lastName}
        />
        <Input
          type="text"
          label="Nombre"
          fieldName="firstName"
          register={register}
          required
          error={errors.firstName}
        />
        <Input
          type="email"
          label="Email"
          fieldName="email"
          register={register}
          required
          error={errors.email}
        />

        <Input type="text" label="DNI" fieldName="DNI" register={register} />
        
        <PhoneNumber 
          fieldName="phoneNumber"
          label="Teléfono" 
          error={errors.phoneNumber} 
          control={control} 
          required    
        />

        <div className="flex items-center mt-4">
          <InputRadio
            label="¿Habilitado para recibir emails de facturación?"
            fieldName="billingEmailEnabled"
            option1="Si"
            option2="No"
            register={register}
            //required
            error={errors?.billingEmailEnabled}
            globalContainerStyles="mt-5"
          />
        </div>

        <PrimaryButton
          type="submit"
          text="Crear"
          styles="bg-red-500 font-bold text-white mt-8"
          disabled={isLoading}
        />
      </form>
    </Modal>
  );
};

export default AddRRHH;
